// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jn-6";
export var emphasizeQuantity = "_jn-3";
export var flatBottomCorners = "_jn-5";
export var productImage = "_jn-0";
export var quantityContainer = "_jn-2";
export var tooltip = "_jn-1";
export var wrapAndEllipsesOverflow = "_jn-4";